const sendGAEvent = event => {
  if (window.dataLayer) {
    window.dataLayer.push(event);
  }
};

const gaEventForSend = eventLabel => {
  sendGAEvent({
    event: "custom_event",
    event_category: "rentals_show",
    event_action: "contact",
    event_label: eventLabel
  });
};

const gaEventForClick = (eventAction, stickyVisible) => {
  sendGAEvent({
    event: "custom_event",
    event_category: "rentals_show",
    event_action: eventAction,
    event_label: stickyVisible ? "sticky" : "inline"
  });
};

export { gaEventForSend, gaEventForClick };
